export default {
    job_level: [
        "administrator_principal_superintendent",
        "biomedical_engineer",
        "c_level_executive",
        "clinical_preclinical",
        "dean_department_head",
        "dentist",
        "designer",
        "educator",
        "engineer",
        "equipment_manufacturer",
        "lab_owner",
        "lab_technician",
        "marketing",
        "medical_education_and_training",
        "parent",
        "practicing_physician",
        "president_provost",
        "prosthetist_orthotist",
        "purchasing",
        "quality",
        "rd_engineering",
        "sales",
        "senior_management_administration",
        "student",
        "training",
        "other"
    ],
    countries: Grabcad.countries || [],
    states: Grabcad.states || [],
    uses_printer_for: [
        "professional",
        "education",
        "hobby",
        "dont_use"
    ],
    company_size: [
        "0 - 100",
        "100 - 500",
        "500 - 1,000",
        "1,000 - 2,500",
        "2,500 - 5,000",
        "5,000 - 10,000",
        "10,000 - 15,000",
        "15,000 - 20,000",
        "20,000+",
        "not_company"
    ],
    industry_vertical: [
        "aerospace",
        "architecture",
        "arts_entertainment",
        "automotive",
        "commercial_products",
        "consumer_electronics",
        "consumer_goods",
        "dental",
        "education",
        "engineering_consulting_service",
        "government_military",
        "industrial_equipment",
        "jewelry",
        "medical_device",
        "service_bureau",
        "toys",
        "reseller",
        "other"
    ],
    yes_no: [
        "yes",
        "no"
    ]
}
